import {ReactElement} from 'react';
import {WhyDataRequired} from 'components/WhyDataRequired';
import {GroupTitle, Fields} from './styled';

type Props = {
  title: string;
  children: ReactElement | ReactElement[] | undefined;
  withWhyDataRequired?: boolean;
};
export const FieldGroup = ({title, children, withWhyDataRequired}: Props) => {
  return (
    <>
      <GroupTitle>
        <span>{title}</span> {withWhyDataRequired && <WhyDataRequired />}
      </GroupTitle>
      <Fields>{children}</Fields>
    </>
  );
};
